module.exports = __webpack_public_path__ + "static/media/undraw_personal_finance_tqcd.886e4ad5.png";